export enum FlyTicketType {
  FlyTicket = "fly-ticket",
  ETravel = "e-travel",
}
